<template>
   <div>
      <div v-if="tradingAccountList.totalLiveAccounts > 0">
         <div
            v-if="
          parseInt(get_user.profile.gAuthenticatorEnabled) == 0 &&
          authComponent &&
          transaction_id != '' &&
          !congModuleWithdrawal
        "
         >
            <app-twofa :call_from="request_page"></app-twofa>
         </div>
         <div v-else>
            <div class="mainTitle text-center my-3">
               <h2 class="mb-3">{{ $t("wit_withdrawal") }}</h2>
               <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
            </div>
            <!--loader - message--->
            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
            <div class="row no-gutters justify-content-center">
               <div class="whiteBG p-4 mb-3 middleBox">
                  <div class="justify-content-center">
                     <!--------------request page---------------------------------->
                     <div class="partcipate-fund" v-if="transaction_id == '' && !congModuleWithdrawal">
                        <div class="form-group field-wrapper" v-if="callFrom != 'wallet'">
                           <account-id></account-id>
                        </div>
                        <div class="form-group field-wrapper" v-if="account_id != ''">
                           <input placeholder=" " type="text" v-model="free_margin_currency" name="free_margin" class="float-field form-control" readonly />
                           <label for="password" class="float-label">{{ $t("wit_freeMargin") }}</label>
                        </div>
                        <div class="form-group field-wrapper dob" v-if="free_margin !== '' && parseInt(free_margin) == 0">
                           <ul>
                              <li>{{ $t("wit_withdrawalMsz1") }}</li>
                           </ul>
                        </div>
                        <!-- <div v-if="free_margin !== '' && parseInt(free_margin) !== 0 && allowedWithdrawal == ''"> -->
                        <div v-if="free_margin !== '' && parseInt(free_margin) !== 0 && allowedWithdrawal != ''">
                           <!-- {{ allowedWithdrawal }}---{{ allowedWithdrawal[key] }} -->
                           <!-- {{ withdrawalMethodResponseDep }} ---- {{ allowedWithdrawal }} -->
                           <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-1" v-if="Object.keys(allowedWithdrawal).length > 0">
                              <div class="withdrwal_cardList d-flex w-100 justify-content-center" v-for="(list, key) in allowedWithdrawal" v-if="parseInt(key) != 4" >
                                 <ul class="twoColumn flex-wrap depositpaymentMethod w-100">
                                    <li class="mb-2 mr-2" v-for="(inlist, inkey) in allowedWithdrawal[key]" :class="parseInt(account_number) == parseInt(inkey) ? 'selected' : '' + `${key}`" v-if="inlist.allowed && parseInt(inlist.allowed) == 1">
                                       <label class="customRadio-button d-flex justify-content-start align-items-center">
                                          <div class="lft d-flex align-items-center mr-3">
                                             <img v-if="key == '17' || key == '19' || key == '20'" :src="'../../../../static/fxView/images/praxis.svg'" alt="Bank Account" class="mr-2" />
                                             <!-- {{$env_var.withdrawalMethod}} -->
                                             <img v-else :src="'../../../../static/fxView/images/' + $env_var.withdrawalMethod[key]" alt="Bank Account" class="mr-2" />
                                          </div>
                                          <div class="rft">
                                             <input
                                                type="radio"
                                                name="radio"
                                                :value="key"
                                                v-model="pay_option"
                                                v-validate="{ required: true }"
                                                class="float-field form-control"
                                                :class="{'is-invalid': submitted && errors.has('radio'), }"
                                                ref="radioInput"
                                                @click="selectpaymentFunc(key,inkey,inlist[currencyData])"
                                             />
                                             <span class="checkmark"></span>
                                          </div>
                                          <div class="d-flex flex-wrap">
                                             <p v-if="showBalPanel">
                                                {{ $t("wit_PrincipalWithAmount") }}
                                                <strong>{{ $env_var.currencyIcon[currencyData] }} {{parseFloat(inlist[currencyData]).toFixed(2)}}</strong>
                                             </p>
                                             <p v-if="key == 1">
                                                {{ $t("wit_AccNumber") }} : {{withdrawalMethodResponseDep[key][inkey].account_no}}
                                             </p>
                                             <p v-if="key == 2">
                                                {{ $t("wit_skrillId") }} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}
                                             </p>
                                             <p v-if="key == 3">
                                                {{ $t("wit_netId") }} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}
                                             </p>
                                             <p v-if="key == 5">
                                                {{ $t("wit_creditCardNumber") }} : **** **** **** {{withdrawalMethodResponseDep[key][inkey].last_digit_card}}
                                                <br />
                                                {{ $t("wit_expiryDate") }} : {{withdrawalMethodResponseDep[key][inkey].card_month }}/{{withdrawalMethodResponseDep[key][inkey].card_year}}
                                             </p>
                                          </div>
                                       </label>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                           <div class="form-group flex-wrap d-flex justify-content-start align-items-center field-wrapper mb-3" v-if="Object.keys(allowedWithdrawal).length > 0">
                              <div class="withdrwal_cardList d-flex w-100 justify-content-center" v-for="(list, key) in allowedWithdrawal" v-if="parseInt(key) != 4">
                                 <ul class="twoColumn flex-wrap depositpaymentMethod w-100">
                                    <li class="mb-2 mr-2" v-for="(inlist, inkey) in allowedWithdrawal[key]" v-if="!inlist.allowed">
                                       <label class="customRadio-button d-flex justify-content-start align-items-center customdisabled">
                                          <div class="lft d-flex align-items-center mr-3">
                                             <img v-if="key == '17' || key == '19' || key == '20'" :src="'../../../../static/fxView/images/praxis.svg'" alt="Bank Account" class="mr-2" />
                                             <img v-else :src="'../../../../static/fxView/images/' +  $env_var.withdrawalMethod[key]" alt="Bank Account" class="mr-2" />
                                          </div>
                                          <div class="rft">
                                             <input type="radio" name="pay_option_disable" :value="key" v-model="pay_option_disable" @click="disableOption()" />
                                             <span class="checkmark"></span>
                                          </div>
                                          <div class="d-flex flex-wrap">
                                             <p v-if="showBalPanel">
                                                {{ $t("wit_PrincipalWithAmount") }}
                                                <strong>{{ $env_var.currencyIcon[currencyData] }} {{ inlist[currencyData] }} </strong>
                                             </p>
                                             <p v-if="key == 1">
                                                {{ $t("wit_AccNumber") }} : {{ withdrawalMethodResponseDep[key][inkey].account_no}}
                                             </p>
                                             <p v-if="key == 2">
                                                {{ $t("wit_skrillId") }} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id }}
                                             </p>
                                             <p v-if="key == 3">
                                                {{ $t("wit_netId") }}: {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}
                                             </p>
                                             <p v-if="key == 5">
                                                {{ $t("wit_creditCardNumber") }} : **** **** **** {{withdrawalMethodResponseDep[key][inkey].last_digit_card}}
                                                <br />
                                                {{ $t("wit_expiryDate") }} : {{withdrawalMethodResponseDep[key][inkey].card_month}}/{{ withdrawalMethodResponseDep[key][inkey].card_year}}
                                             </p>
                                          </div>
                                       </label>
                                    </li>
                                 </ul>
                              </div>
                              <p class="error mb-3" v-if="pay_option == '' && getMsz">
                                 {{ $t("wit_allowOption") }}
                              </p>
                              <p class="error mb-3" v-if="!getMsz && errors.first('radio')">
                                 {{ $t("wit_WithdrawalMethodReq") }}
                              </p>
                           </div>
                           <div class="clearfix"></div>
                           <!---->
                           <div class="form-group field-wrapper" v-if="select_crypto">
                               <select  class="float-field form-control" :class="{ 'is-invalid': submitted && errors.has('Crypto Address')}" v-model="selectcurrency" name="Crypto Address" v-validate="{ required: true }">
                                  <option value="">{{$t('fxSelectCryptoAddress')}}</option>
                                  <option v-for="list in withdrawalMethodResponse['18']" :value="list" v-if="list.last_digit_card !=''">
                                     {{ handleCryptoList(list.last_digit_card) }} - {{ list.online_payment_id }}
                                  </option>
                               </select>
                               <p v-for="error in errors.collect('Crypto Address')" style="color: #F2636A">{{error}}</p>
                            </div>
                           <div class="form-group field-wrapper" v-if="Object.keys(allowedWithdrawal).length > 0">
                              <input
                                 placeholder=" "
                                 type="text"
                                 v-model="amount"
                                 v-validate="{ required: true }"
                                 name="amount"
                                 class="float-field form-control"
                                 :class="{
                                   'is-invalid': submitted && errors.has('amount'),
                                 }"
                                 ref="amountInput"
                              />
                              <label for="password" class="float-label">{{ $t("wit_EnterWithdrawal") }} {{ $t("Wal_detail_Amount") }}</label>
                              <ul>
                                 <li v-for="error in errors.collect('amount')">
                                    {{ error }}
                                 </li>
                              </ul>
                              <p class="error" v-if="amount_msg != ''">
                                 {{ amount_msg }}
                              </p>
                           </div>
                           <div class="clearfix"></div>
                           <!------------------------------------------------------------>
                           <!-- 24hr withdrawal -->
                           <!-- <div v-if="countDownTab" class="withdrawalflipCountDown text-center pt-3 mb-3">
                             <span class="pt-3">{{$t('wit_requestWithdrawal')}}</span> </p>
                           </div>
                           <div class="submitButton w-100 mt-2 text-center" >
                             <button class="prism_btn btn_sm" v-on:click.prevent="submitRequestOtp()" :class="(countDownTab)?'disabled':''"> {{$t('wit_withdrawal')}} </button>
                           </div> -->
                           <!-- end -->
                           <!-- without 24hr check -->
                           <div class="submitButton w-100 mt-2 text-center" v-if="Object.keys(allowedWithdrawal).length > 0">
                              <button class="prism_btn btn_sm" v-on:click.prevent="submitRequestOtp()">
                                 {{ $t("wit_withdrawal") }}
                              </button>
                           </div>
                           <!-- end -->
                        </div>
                     </div>
                     <!------------------------------------------------------------->
                     <div class="partcipate-fund" v-if="transaction_id != '' && !congModuleWithdrawal">
                        <div v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
                           <p class="mb-3 text-center">
                              {{ $t("rb_googleAuth1") }}
                              <strong>{{ $t("rb_googleAuth2") }}</strong>
                              {{ $t("rb_googleAuth3") }}.
                           </p>
                           <div class="form-group field-wrapper">
                              <input
                                 type="text"
                                 placeholder="000 000"
                                 class="mdb-select md-form form-control"
                                 v-model="otp"
                                 v-validate="{ required: true, max: 6, numeric: true }"
                                 name="otp"
                                 :class="{
                                   'is-invalid': submittedCheckOtp && errors.has('otp'),
                                 }"
                                 ref="otpInput"
                                 @keyup.enter="submitCheckOtp()"
                              />
                              <ul>
                                 <li v-for="error in errors.collect('otp')">
                                    {{ error }}
                                 </li>
                              </ul>
                           </div>
                           <div class="form-group text-center field-wrapper">
                              <button class="prism_btn btn_sm" v-on:click.prevent="submitCheckOtp()">
                                 {{ $t("rb_validate") }}
                              </button>
                           </div>
                           <div class="clearfix"></div>
                           <div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                              <div class="desc text-center">
                                 <p>
                                    {{ $t("rb_googleAuth4") }}
                                    <a v-on:click.prevent="resendLink()" href="#"><strong>{{ $t("rb_googleAuth5") }}</strong></a>
                                 </p>
                              </div>
                           </div>
                           <div class="clearfix"></div>
                        </div>
                        <div
                           class="middleBox1"
                           v-if="
                             parseInt(get_user.profile.gAuthenticatorEnabled) == 0 &&
                             !authComponent
                           "
                           >
                           <div class="congratulations">
                              <div class="logo_congrats">
                                 <img src="../../../../static/fxView/images/withdraw.svg" alt="Icon" />
                              </div>
                              <div class="subtitle">
                                 <p class="mb-3">
                                    {{ $t("verf_dear") }}
                                    <strong class="green">{{ get_user.username }} !</strong>
                                    {{ $t("VpsSub_withdrawalAuthMessage") }}
                                    <strong>{{ get_user.email }} . </strong>
                                 </p>
                                 <a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{ $t("rb_googleAuth7") }}</strong></a>
                              </div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
                              <div class="ico mr-3">
                                 <img src="../../../../static/fxView/images/google_auth.png" alt="2fa" />
                              </div>
                              <div class="desc w-75">
                                 <h5 class="mb-2">
                                    <strong>{{ $t("rb_googleAuth8") }}</strong>
                                 </h5>
                                 <p>
                                    {{ $t("rb_googleAuth9") }}
                                    <a v-on:click.prevent="authComponent = true" href="#"><strong>{{ $t("rb_googleAuth10") }}</strong></a>
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <!------------congo msz final for withdrawal page------------------------->
                     <div class="stepForm" v-if="congModuleWithdrawal">
                        <div class="congratulations">
                           <div class="logo_congrats">
                              <img src="../../../../static/fxView/images/check.svg" alt="Icon" />
                           </div>
                           <div class="subtitle">
                              <h3>
                                 {{ $t("rb_congo") }}
                                 <span class="green">{{ get_user.username }}</span>
                              </h3>
                              <p>{{ $t("wit_withdrawalMsz2") }}</p>
                           </div>
                           <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                              <a href="#" class="prism_btn btn_sm" @click.prevent="back()">{{ $t("withdraw_backWithdraw") }}</a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="CustomBlockWidth resPadding" v-if="transaction_id == '' && !congModuleWithdrawal">
               <div class="row no-gutters justify-content-center">
                  <div class="whiteBG p-4 middleBox">
                     <div class="note-list">
                        <ul class="dotIco">
                           <li>{{ $t("wit_withCont1") }}</li>
                           <li>{{ $t("wit_withCont2") }}</li>
                           <li>{{ $t("wit_withCont3") }}</li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div v-else-if="tradingAccountList.totalLiveAccounts == 0">
         <div class="mainTitle text-center my-3">
            <h3>{{ $t("VpsSub_noTradingAccFound") }}</h3>
         </div>
         <no-trading-account></no-trading-account>
      </div>
      <div v-else class="text-center p-5 customLoader">
         <div class="loader"></div>
         <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
      </div>
   </div>
 </template>
 <script>
   import { fxViewMixins } from "@/plugins/fxView";
   import FlipCountdown from "vue2-flip-countdown";
   import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
   import twoFa from "../users/2FA";
   import moment from "moment";
   export default {
      name: "Withdrawal",
      mixins: [fxViewMixins],
      data() {
         return {
          crypto_Id:18,
          selectcurrency:"",
          apiCryptoAddress: "",
          PaymentMethodList: [],
          select_crypto: false,
          pageName: this.$options.name,
          //============message and loader ===========
          response_msg: "",
          msg_type: "",
          showBalPanel: true,
          amount_msg: "",
          pageLoader: false,
          loaderFuncRun: "1",
          //==========================================
          balance: "",
          free_margin: "",
          allowedWithdrawal: {},
          amount: "",
          pay_option: "",
          account_number: "",
 
          submitted: false,
          authComponent: false,
          //-----select account----
          selectAccount: false,
          account_id: "",
          act_account_id: "",
          demo_live: "",
          platform: "",
          currencyData: "",
          free_margin_currency: "",
          //=====================
 
          otp: "",
          transaction_id: "",
          submittedCheckOtp: false,
          congModuleWithdrawal: false,
          pay_option_disable: "",
 
          request_page: "withdrawal",
          avalBalance: "",
 
          finish_date: "",
          countDownTab: false,
          getMsz: false,
         };
      },
      components: {
         appTwofa: twoFa,
         FlipCountdown,
      },
      props: ["callFrom"],
      methods: {
          getCryptoAddress(val) {
             this.apiCryptoAddress = "";
             let list = this.PaymentMethodList.data.data;
             let sorted = list.find((res) => res.last_digit_card == val);
             if (sorted) {
                this.apiCryptoAddress = sorted.online_payment_id;
             } else {
                this.apiCryptoAddress = "";
             }
             return this.apiCryptoAddress;
             // this.select_option_method('18')
          },
          handleCryptoList(list) {
             let out = list;
             if(!['BTC', 'TRXUSDT', 'TRXUSDC', 'USDT(TRC20)', 'USDC(TRC20)'].includes(list)) {
                out += '(ERC20)';
             } else if (['TRXUSDT'].includes(list)) {
                out = 'USDT(TRC20)';
             } else if (['TRXUSDC'].includes(list)) {
                out = 'USDC(TRC20)';
             } else {
                out = list;
             }
                return out;
          },
         back() {
            this.transaction_id = "";
            this.amount = "";
            this.free_margin = "";
            this.account_id = "";
            this.act_account_id = "";
            this.pay_option = "";
            this.account_number = "";
            this.congModuleWithdrawal = false;
         },
         selectpaymentFunc(getMethodId, getPaymentId, amount) {
            this.getMsz = false;
            if(getMethodId == '18'){
                this.select_crypto = true
                this._runGetWithdrawalMethods({
                      globalParams: {},
                      localParams: {
                         parameter: this,
                         loaderFuncRun: this.loaderFuncRun,
                      },
                });
            }else{
                this.select_crypto = false
            }
            if (this.showBalPanel === true && getPaymentId !== '0') {
               let payment_method_date = moment(this.withdrawalMethodResponseDep[getMethodId][getPaymentId].created).format("YYYY-MM-DD hh:mm:ss");
               this.finish_date = moment(payment_method_date).add(24, "hours").format("YYYY-MM-DD hh:mm:ss");
               var currentDate = moment().format("YYYY-MM-DD hh:mm:ss");
               if (this.finish_date <= currentDate) {
                  this.countDownTab = false;
               } else {
                  this.countDownTab = true;
               }
               this.account_number = getPaymentId;
            }
            this.avalBalance = amount;
         },
         disableOption() {
            this.getMsz = true;
         },
         resendLink() {
            let input_json = {
               globalParams: {
                  trans_id: this.transaction_id.toString(),
               },
               localParams: { parameter: this },
            };
            this._runResendEmailLink(input_json);
         },
         tradingAcountSelect() {
            let input_json1 = {
               globalParams: {
                  account_id: this.account_id,
                  act_account_id: this.act_account_id,
                  demo_live: this.demo_live,
                  currency: this.currencyData,
                  platform: this.platform,
               },
               localParams: { parameter: this },
            };
            this._runGetWithdrawalDesc(input_json1);
         },
         submitRequestOtp() {
            this.$trackEvent('CP+Account+Funding+Withdrawals')
            this.amount_msg = "";
            const _that = this;
            let crypto_address_detail=""
          if(_that.pay_option == '18'){
            _that.act_account_id = _that.selectcurrency.id
            crypto_address_detail=_that.selectcurrency.last_digit_card+"-"+_that.selectcurrency.online_payment_id
            if (this.showBalPanel === false && Object.keys(this.allowedWithdrawal['18']) && Object.keys(this.allowedWithdrawal['18']).length && Object.keys(this.allowedWithdrawal['18']).length === 1 && Object.keys(this.allowedWithdrawal['18'])[0] === '0') {
               _that.account_number = _that.selectcurrency.id;
            }
          }
            _that.submitted = true;
            _that.$validator.validate().then((valid) => {
               if (valid) {
                  if (parseFloat(_that.amount) <= parseFloat(_that.free_margin) && parseFloat(_that.amount) <= parseFloat(_that.avalBalance) && _that.amount > 0) {
                     _that.amount_msg = "";
                     let input_json = {
                        globalParams: {
                           account_id: _that.account_id,
                           act_account_id: _that.act_account_id,
                           withdrawal_method: _that.pay_option,
                           method_id: _that.account_number.toString(),
                           amount: _that.amount,
                           crypto_address: crypto_address_detail,
                           operation: "WITHDRAWAL",
                        },
                        localParams: { parameter: _that },
                     };
                     _that._runWithdrawalRequestOtp(input_json);
                  } else {
                     if (parseFloat(_that.free_margin) <= parseFloat(_that.avalBalance)) {
                      
                        _that.amount_msg = "Max amount you can withdraw is " + _that.free_margin;
                     }else if(parseFloat(_that.amount) > parseFloat(_that.avalBalance)) {
                         _that.amount_msg = "Max amount you can withdraw is " + _that.avalBalance;
                      }else{
                         _that.amount_msg = "Max amount you can withdraw is " + _that.free_margin_currency;
                      }
                  }
               } else {
                  _that.handleValidationErrorAdvanced(_that.errors);
               }
            });
         },
         submitCheckOtp() {
            const _that = this;
            _that.submittedCheckOtp = true;
            _that.$validator.validate().then((valid) => {
               if (valid) {
                  let input_json = {
                     globalParams: {
                        google_token: _that.otp.toString(),
                        trans_id: _that.transaction_id.toString(),
                     },
                     localParams: { parameter: _that },
                  };
                  _that._runWithdrawalCheckOtp(input_json);
               } else {
                  _that.handleValidationErrorAdvanced(_that.errors);
               }
            });
         },
      },
      created() {
         if (this.callFrom != "" && this.callFrom != null && this.callFrom != undefined) {
            this.account_id = this.walletAccount.records[0].account_id;
            this.act_account_id = this.walletAccount.records[0].act_account_id;
            this.demo_live = this.walletAccount.records[0].demo_live;
            this.platform = this.walletAccount.records[0].platform;
            this.currencyData = this.walletAccount.records[0].currency;
            this.tradingAcountSelect();
         }
         if (this.$store.getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE] != "") {
            this.loaderFuncRun = "0";
         }
         this._runGetWithdrawalMethods({
            globalParams: {},
            localParams: { parameter: this, loaderFuncRun: this.loaderFuncRun },
         });
      },
   };
 </script>


// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal.vue